/**
 * Central registry of localStorage keys.
 * Use these constants instead of magic strings to avoid typos and collisions.
 * Keys match existing values for backward compatibility.
 */

export const StorageKeys = {
	// Shift
	shiftSelectedGroup: "shift:selectedGroup:v1",
	shiftColumnVisibility: "shiftlog:columnVisibility:v1",
	shiftEventSections: "shiftEvent:sections:v1",

	// Tasks
	selectedGroupIds: "selectedGroupIds",

	// Procedures
	procOnlyMatches: "proc.onlyMatches",
	procOpenFolders: "proc.openFolders",
	procSelectedFolder: "proc.selectedFolder",
	procedureFoldersState: "procedureFoldersState",
	procedureKnowledgeConfirmed: (id: number | string) =>
		`procedureKnowledgeConfirmed_${id}`,
	suggestionSelection: (page: string) => `suggestionSelection_${page}`,

	// Checklists
	checklistFontScale: "checklist-view-font-scale",
	checklistHeaderCollapsed: "checklist-view-header-collapsed",
	checklistEditorSplitSizes: "checklist-editor-split-sizes",

	// Procedure page
	procedureSplitSizes: "procedure-split-sizes",

	// Training (dynamic keys)
	kpiSelectedMetric: (field: string) => `training.kpi.metric.${field}`,
	upcomingSessionsSortOrder: (type: string, data: string) =>
		`upcomingSessions.sortOrder.${type}.${data}`,

	// Lab
	labMeasurementStatisticsVisible: "labMeasurementStatisticsVisible",

	// Organizations
	recentCompanies: "recentCompanies",

	// Material handling
	materialHandlingFavorites: "materialHandlingFavoriteState",
	materialHandlingMaxFavorites: "materialHandlingFavoriteMaxNumberOfFavorites",
} as const;
